import { render, staticRenderFns } from "./the-footer.vue?vue&type=template&id=fa04a4cc&scoped=true&lang=pug"
import script from "./the-footer.js?vue&type=script&lang=js&external"
export * from "./the-footer.js?vue&type=script&lang=js&external"
import style0 from "./the-footer.vue?vue&type=style&index=0&id=fa04a4cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa04a4cc",
  null
  
)

export default component.exports